// Reserved keywords not allowed to use in the parser
export var keywords = {
  end: true
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/expression/keywords.js
// module id = 660
// module chunks = 0